import { RouteConfig } from 'vue-router'
import routeAccount from './routeAccount'
import routeAdministration from './routeAdministration'
import routeCalendar from './routeCalendar'
import routeDashboard from './routeDashboard'
import routeLessons from './routeLessons'
import routeMessages from './routeMessages'
import routeMyFolder from './routeMyFolder'
import routePolicy from './routePolicy'
import routeSession from './routeSession'
import routeRecognition from './routeRecognition'
import routeELibrary from './routeELibrary'
import routeMyFiles from 'src/router/routeMyFiles'
import routeTuitionTracker from 'src/router/routeTuitionTracker'
import routeAuth from 'src/router/routeAuth'

const routes: RouteConfig[] = [
  { path: '', redirect: '/dashboard' },
  {
    path: '/login',
    name: 'login',
    component: () => import('layouts/AuthLayout.vue')
  },
  {
    path: '/notregistered',
    name: 'notregistered',
    component: () => import('layouts/EmailNotRegistered.vue')
  },
  {
    path: '/notsupported',
    name: 'notSupported',
    component: () => import('pages/NotSupported.vue')
  },
  {
    path: '/accountdisabled',
    name: 'accountDisabled',
    component: () => import('layouts/AccountDisabled.vue')
  },
  {
    path: '/codeofconduct',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/CodeOfConduct/Index.vue')
      }
    ],
    meta: { requiresAuth: true }
  },
  ...routeAccount,
  ...routeAdministration,
  ...routeCalendar,
  ...routeDashboard,
  ...routeLessons,
  ...routeSession,
  ...routeMessages,
  ...routeMyFolder,
  ...routePolicy,
  ...routeRecognition,
  ...routeELibrary,
  ...routeMyFiles,
  ...routeTuitionTracker,
  ...routeAuth
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default routes
